import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "16",
  x: "2",
  y: "2",
  fill: "#D24625",
  rx: "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M10.145 10.973h-1.45v-.914h1.45c.223 0 .406-.037.546-.11A.702.702 0 0 0 11 9.637a1.146 1.146 0 0 0 0-.922.79.79 0 0 0-.309-.352c-.14-.088-.323-.133-.546-.133H9.102V13H7.93V7.313h2.215c.445 0 .826.08 1.144.242.32.159.565.379.734.66.17.281.254.603.254.965 0 .367-.084.685-.254.953-.169.268-.414.475-.734.62-.318.147-.7.22-1.144.22"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }